import { render, staticRenderFns } from "./PrimaryCard.vue?vue&type=template&id=b720e428&scoped=true&"
import script from "./PrimaryCard.vue?vue&type=script&lang=js&"
export * from "./PrimaryCard.vue?vue&type=script&lang=js&"
import style0 from "./PrimaryCard.vue?vue&type=style&index=0&id=b720e428&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b720e428",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDivider,VImg,VRow})
